var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{ref:this.ident,class:this.defaultClass + ' close',attrs:{"id":this.ident,"name":this.ident,"value":this.value},on:{"click":_vm.remove}},[_vm._v("×")])}
var staticRenderFns = []

export { render, staticRenderFns }